import FadeIn from "../../ui/FadeIn";
import Quote from "../../../svg/Quote";
import SiteService from "../../../services/SiteService";

export default function ArticleQuote({ part, article }) {
	function Quote2() {
		return (
			<div className={'quoteContainer'}>
				<q><Quote />{part.value}</q>
			</div>
		);
	}

	function Quote1() {
		return (
			<div className={'quoteContainer quoteContainer2'}>
				<q>“ {part.value} ”</q>
			</div>
		);
	}

	function Quote3() { // only for debate/
		return (
			<div className={'quoteContainer3'}>
				<div>“</div>
				<q>{part.value}</q>
				<div>- {article.author?.name}</div>
			</div>
		);
	}

	function SeilasQuote() {
		return (
			<div className={'quoteContainer'}>
				<q style={{textAlign:'center', color:'#8d734a', fontStyle:'italic'}}>«{part.value}»</q>
			</div>
		);
	}

	let quote = null;
	if (SiteService.appName==='seilas') {
		quote = <SeilasQuote />;
	}
	else if (part.variant == null || part.variant == 1) {
		quote = <Quote1 />;
	}else if(part.variant == 2){
		quote = <Quote2 />;
	}else if(part.variant == 3){
		quote = <Quote3 />;
	}

	return (
		<FadeIn threshold={0.9}>
			{quote}
		</FadeIn>
	);
}
